import { createSelector } from "@reduxjs/toolkit";

const selectUserModule = (state) => state.user;
export const selectLoggedInUserId = (state) => state.user?.user?.id;
export const selectLoggedInUserType = (state) => state.user?.user?.userType;
export const selectLoggedInUsername = (state) => state.user?.user?.username;

export const selectPermissionsMap = createSelector(
  [selectUserModule],
  (user) => user?.formWithPermission || {},
);

export const selectPermissionsByPath = createSelector(
  [selectPermissionsMap, (_, pathname) => pathname],
  (permissionsMap, pathname) => {
    const foundKey = permissionsMap[pathname]
      ? pathname
      : Object.keys(permissionsMap).find((key) => pathname.startsWith(key));

    const permissionData = foundKey ? permissionsMap[foundKey] : null;

    // Get the array from nested object
    const permissionsArray = permissionData?.permissions || [];

    return new Set(permissionsArray);
  },
);
